import React, { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import SocialBtns from '../SocialBtns';
import { Icon } from '@iconify/react';
import { pageTitle } from '../../helpers/PageTitle';

export default function DetailsPage3() {
    pageTitle('Career');
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Breadcrumb title="Career" bgUrl="/images/career.jpg" />

            <section className="cs_pt_130 cs_pt_lg_80 cs_pb_93 cs_pb_lg_80">
                <div className="container">
                    <div>
                        <div className="cs_project_details-head d-flex align-items-center justify-content-between flex-wrap cs_mb_40 cs_row_gap_15 cs_column_gap_15">
                            <h2 className="m-0 cs_fs_48 cs_fs_lg_36">Computer Application Programmer</h2>
                            <div className="cs_published_date d-inline-flex cs_rounded_5 bg-accent text-white cs_pt_5 cs_pb_5 cs_pl_15 cs_pr_15 cs_pt_lg_3 cs_pb_lg_3">
                                01 July, 2025
                            </div>
                        </div>
                        {/*<img*/}
                        {/*  src="/images/project_details_img.jpeg"*/}
                        {/*  alt="Thumb"*/}
                        {/*  className="cs_mb_60 cs_mb_lg_40"*/}
                        {/*/>*/}
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="cs_project_details cs_pb_40">
                                    <p className="m-0">
                                        <h3>Roles and Responsibilities</h3>
                                        We are seeking a highly skilled Computer Application Programmer to Analyze user needs and software requirements to determine feasibility of design within time and cost constraints.
                                        <br />
                                        <p className="cs_mb_35">
                                            <ul>
                                                <li>
                                                    Design, develop, and modify computer applications software to meet user and business requirements.
                                                </li>
                                                <li>
                                                    Write, test, and maintain code for computer applications using languages such as C#, ASP.NET, JavaScript, SQL, and related technologies.

                                                </li>
                                                <li>
                                                    Develop and integrate RESTful APIs and web services to support front-end and back-end functionalities.

                                                </li>
                                                <li>
                                                    Collaborate with cross-functional teams including business analysts, testers, and project managers to define software specifications.
                                                </li>
                                                <li>Perform unit testing and support software quality assurance efforts across multiple environments
                                                </li>
                                                <li>Maintain detailed documentation for code, system configuration, and application workflows.

                                                </li>
                                                <li>Ensure application security, scalability, and performance best practices are followed.</li>
                                                <li>  Support and maintain existing software systems by identifying areas for improvement and troubleshooting issues.
                                                </li>
                                                <li>Stay updated with emerging technologies and propose integration of relevant tools and frameworks.</li>
                                            </ul>
                                        </p>
                                    </p>{' '}
                                    <br />
                                    <h3 className="text-accent cs_fs_20 cs_lh_base m-0">
                                        Required Skills, Tools and Technologies:
                                    </h3>{' '}
                                    <br />
                                    <p className="cs_mb_35">
                                        C#, VB.NET, ASP.NET, .NET Framework, .NET Core, MVC, JavaScript, JQuery, HTML, CSS, Bootstrap, SQL, T-SQL, XML, JSON, RESTful APIs, Web Services, AJAX, Microsoft SQL Server, Visual Studio, Git, GitHub, GitLab, Azure DevOps, Postman, Microsoft Azure, AWS, Agile, Scrum.
                                    </p>
                                    {/*<h4 className="cs_fs_18 cs_mb_12">Project Challenges : </h4>*/}
                                    {/*<ul className="cs_mb_30 cs_list cs_style_1">*/}
                                    {/*  <li>*/}
                                    {/*    <Icon icon="fa-solid:check" />*/}
                                    {/*    Nemo enim ipsam voluptatem quia voluptas mus et iusto odio*/}
                                    {/*  </li>*/}
                                    {/*  <li>*/}
                                    {/*    <Icon icon="fa-solid:check" />*/}
                                    {/*    Vivamus vel eros vitae est aliquet pellentesque*/}
                                    {/*  </li>*/}
                                    {/*  <li>*/}
                                    {/*    <Icon icon="fa-solid:check" />*/}
                                    {/*    If you are going to use a passage of Lorem Ipsum*/}
                                    {/*  </li>*/}
                                    {/*</ul>*/}
                                    <h3 className="text-accent cs_fs_20 cs_lh_base m-0">
                                        Qualified Candidates Should Send Their Resumes To:
                                    </h3>{' '}
                                    <p className="m-0">
                                        <a href="mailto:hr@crescentitsolutions.com" className="text-accent cs_fs_20 cs_lh_base m-0">hr@crescentitsolutions.com</a> Or Drop at
                                        Crescent IT Solutions Inc. 2454 E Dempster St, Suite 204 Desplaines, IL 60016 Phone: <a href="tel:7086670871">
                                            (708) 667-0871</a>
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <ul className="cs_project_details-info bg-white cs_rounded_20 m-0 cs_pl_50 cs_pt_50 cs_pr_50 cs_pb_50 cs_pl_lg_40 cs_pt_lg_40 cs_pr_lg_40 cs_pb_lg_40">
                                    <li>
                                        <h3 className="cs_fs_18 cs_mb_10">Position:</h3>
                                        <p className="m-0">Computer Application Programmer</p>
                                    </li>
                                    {/*<li>*/}
                                    {/*  <h3 className="cs_fs_18 cs_mb_10">Client:</h3>*/}
                                    {/*  <p className="m-0">Kristin Watson</p>*/}
                                    {/*</li>*/}

                                    <li>
                                        <h3 className="cs_fs_18 cs_mb_10">Date of Opening :</h3>
                                        <p className="m-0">July 01, 2025</p>
                                    </li>

                                    <li>
                                        <h3 className="cs_fs_18 cs_mb_10">Date of Closing :</h3>
                                        <p className="m-0">September 30, 2025</p>
                                    </li>
                                    <li>
                                        <h3 className="cs_fs_18 cs_mb_10">Working Days and Hours: :</h3>
                                        <p className="m-0">Monday to Friday, 9:00 am to 5:00 pm</p>
                                    </li>
                                    <li>
                                        <h3 className="cs_fs_18 cs_mb_10">Salary :</h3>
                                        <p className="m-0">  $79,706</p>
                                    </li>
                                    <li>
                                        <h3 className="cs_fs_18 cs_mb_10">Location :</h3>
                                        <p className="m-0">{/*5901 N Cicero Ave, */}Chicago, IL</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}
